import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "Download";
export const DownloadArquivo = (arquivoId) =>
  RequestWebApi.get(`/${controller}/DownloadArquivo`, {
    params: { arquivoId: arquivoId },
    responseType: "blob",
  })
    .then(function (response) {
      const type = response.headers["content-type"];
      const blob = new Blob([response.data], { type: type, encoding: "UTF-8" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `Arquivo_${arquivoId}`;
      link.click();
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { filaAtendimento: [] };
    });

export const DownloadTemplate = (nomeTemplate) =>
  RequestWebApi.get(`/${controller}/DownloadTemplate`, {
    params: { nomeTemplate: nomeTemplate },
    responseType: "blob",
  })
    .then(function (response) {
      const type = response.headers["content-type"];
      const blob = new Blob([response.data], { type: type, encoding: "UTF-8" });
      const link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = nomeTemplate;
      link.click();
    })
    .catch(function (error) {
      validateRequestErrorStatus(error.response.status);
      return { filaAtendimento: [] };
    });

export const DownloadArquivoFisico = (arquivoNome, arquivoNomeDownload) =>
  RequestWebApi.get(`/${controller}/DownloadArquivoFisico`, {
    params: { arquivoNome },
    responseType: "blob",
  })
    .then((response) => {
      const type = response.headers["content-type"];
      const blob = new Blob([response.data], { type });

      const link = document.createElement("a");
      const url = window.URL.createObjectURL(blob);
      link.href = url;

      // nome final do arquivo que será baixado
      link.download = arquivoNomeDownload || arquivoNome;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // libera memória
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      if (error.response) {
        validateRequestErrorStatus(error.response.status);
      } else {
        console.error("Erro de rede ao tentar baixar o arquivo:", error);
      }
      return { filaAtendimento: [] };
    });

